import { ProductsViewState } from '@models/SavedViews';
import CreateCopyViewButton from '../copy-view/CreateCopyViewButton';
import React from 'react';
import { SavedViewButtonsTrackingTags } from '@ecosystem/newron-client-lib/build/saved-views/types';

export interface Props {
  productsViewState: ProductsViewState;
  copyViewTracking: Object;
}

const ProductsCopyViewButton: React.FC<Props> = ({ productsViewState, copyViewTracking }) => {
  const createTrackingTags = () => {
    return copyViewTracking as SavedViewButtonsTrackingTags;
  };
  return <CreateCopyViewButton createViewFunction={() => productsViewState} copyViewTracking={createTrackingTags} />;
};

export default ProductsCopyViewButton;
